import { render, staticRenderFns } from "./fideicomisoInmobiliaria.vue?vue&type=template&id=6b64ea95&"
import script from "./fideicomisoInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./fideicomisoInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./fideicomisoInmobiliaria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports